<template>
  <div v-if="articleData">
    <div v-for="(item, index) in articleData.articleList" :key="index">
      <div v-if="item.type === 1">
        <div class="has-img" v-if="item.photoPath" @click="jumpDetail(item)">
          <div class="img-box">
            <img :src="item.photoPath" />
          </div>
          <div class="intro">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.modifyTime.slice(0, 10) }}</div>
          </div>
        </div>

        <div class="no-img" v-if="!item.photoPath" @click="jumpDetail(item)">
          <div class="title">{{ item.title }}</div>
          <div class="time">{{ item.modifyTime.slice(0, 10) }}</div>
        </div>
      </div>
      <a v-else-if="item.type === 3" :href="JSON.parse(item.content).link" target="_blank">
        <div class="has-img" v-if="item.photoPath">
          <div class="img-box">
            <img :src="item.photoPath" />
          </div>
          <div class="intro">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.modifyTime.slice(0, 10) }}</div>
          </div>
        </div>

        <div class="no-img" v-if="!item.photoPath">
          <div class="title">{{ item.title }}</div>
          <div class="time">{{ item.modifyTime.slice(0, 10) }}</div>
        </div>
      </a>
    </div>

    <div class="more" @click="more" v-if="articleTotal !== articleData.articleList.length">
      展示更多<van-icon name="arrow-down" />
    </div>

    <no-data :articleData="articleData" :loading="loading"></no-data>
  </div>
</template>

<script>
import NoData from '@/components/NoData';

export default {
  components: {
    NoData,
  },
  props: ['articleData', 'articleTotal'],
  data() {
    return {};
  },
  methods: {
    jumpDetail(val) {
      if (val.menuType === 15 || val.menuType === 16) {
        this.countClick(val.id);
      }
      let query = this.$route.query;
      let params = {
        first: query.first,
        second: query.second,
        detailID: val.id,
        type: val.menuType,
        name: query.name,
      };
      this.$router.push({
        path: 'content',
        query: params,
      });
    },
    more() {
      this.$emit('more');
    },
    countClick(id) {
      let replacement = {
        articleID: id,
      };
      this.$api.countClick(replacement).then((res) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.has-img {
  padding: 20px 0;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  .img-box {
    width: 190px;
    height: 160px;
    margin-right: 26px;
    img {
      width: 190px;
      height: 100%;
    }
  }

  .intro {
    padding-left: calc-width(10vw);
    display: inline-block;
    width: calc-width(196vw);
    vertical-align: top;

    .title {
      color: $list-title-color;
      // margin-bottom: calc-width(32vw);
      display: -webkit-box;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .time {
      color: $time-color;
      font-size: calc-width(12vw);
      margin-top: calc-width(22vw);
    }
  }
}

.no-img {
  padding: calc-width(13vw) 0;
  border-bottom: 1px solid $border-color;
  max-height: calc-width(95vw);

  .title {
    color: $list-title-color;
    margin-bottom: calc-width(5vw);
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .time {
    color: $time-color;
    font-size: calc-width(12vw);
  }
}

.more {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0 -20px 0;
  height: 30px;
  color: #999;
  // background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/List.vue